/**
 * Helper method that returns the first argument passed in.
 *
 * @param {*?} input - Argument to be returned. This is completely optional
 *
 * @returns {*} This returns whatever is passed in.
 */
function indentity(input) {
  return input;
}

module.exports = indentity;
